import { render, staticRenderFns } from "./connections.vue?vue&type=template&id=67d0a47a&scoped=true"
import script from "./connections.vue?vue&type=script&lang=js"
export * from "./connections.vue?vue&type=script&lang=js"
import style0 from "./connections.vue?vue&type=style&index=0&id=67d0a47a&prod&lang=css"
import style1 from "./connections.vue?vue&type=style&index=1&id=67d0a47a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67d0a47a",
  null
  
)

export default component.exports